import {useCallback, useState} from 'react';

// Chakra
import {
    Table,
    Tbody,
    Tr,
    Td,
    useColorModeValue,
    Thead, useDisclosure, Button, Text
} from '@chakra-ui/react';

import Card from 'components/Card/Card';
import WinnerEditModal from './WinnerEditModal';
import {DeleteIcon} from '@chakra-ui/icons';
import {apiService} from 'services/ApiService';
import Attention from 'components/Modals/Attention.js';
import {useQueryClient} from 'react-query';
import {hideString, parseDateTime} from 'services/Utils';

export default function GiveawayWinners({ giveaway, hardShowWinners, isEditable = true }) {
    const queryClient = useQueryClient();
    const [selectedWinner, setSelectedWinner] = useState();
    const [deleteWinnerId, setDeleteWinnerId] = useState(null);
    const textColor = useColorModeValue('gray.700', 'white');

    const handleDeleteWinner = useCallback(async (id) => {
        await apiService.deleteGiveawayWinner({id});
        queryClient.invalidateQueries(['giveawayLogs']);
    }, []);

    const handleRevealWinner = useCallback(async (id) => {
        await apiService.revealGiveawayWinner({id});
        queryClient.invalidateQueries(['giveawayWinners']);
    }, [queryClient]);

    const { isOpen, onOpen, onClose } = useDisclosure();

  const getOrdinalSuffix = useCallback((number) => {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return `${number}th`;
    }

    switch (lastDigit) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  }, []);

  const processWinnerData = useCallback(
    (text, isHidden) => {
      if (!isHidden) {
        return text;
      }
      if (!giveaway) {
        return;
      }
      const declareDate = new Date(giveaway.declareDate);

      const currentDate = new Date();

      const seconds = Math.ceil(
        Math.abs(declareDate.getTime() - currentDate.getTime()) /
          // (1000 * 3600 * 24)
          1000
      );

      if (seconds > 0 && text) {
        return '*'.repeat(text.length);
      } else {
        return text;
      }
    },
    [giveaway, hardShowWinners]
  );

    const goTo = useCallback(
        (startIndex) => {
            const query = startIndex !== undefined ? `?startIndex=${startIndex}` : '';
            const url = `/#/game/slot-machine/${giveaway.id}${query}`;
            window.open(url, '_blank');
        },
        [giveaway]
    );


  return (
    <Card padding='24px' mb='40px'>
      <Table color={textColor}>
        <Thead>
          <Tr>
            <Td>Place</Td>
            <Td>Title</Td>
            <Td>Winner</Td>
            <Td></Td>
            <Td></Td>
          </Tr>
        </Thead>
        <Tbody>
          {giveaway.winners &&
            giveaway.winners.map(({ prize, user, place, id, packageNames, createdAt, isHidden }) => (

              <Tr key={prize.index}>
                <Td>{getOrdinalSuffix(place)}</Td>
                <Td>{prize.title}</Td>
                <Td onClick={()=>{
                    if(isEditable){
                        setSelectedWinner({
                            user:{
                                firstName: prize?.winner?.firstName || user?.firstName,
                                lastName: prize?.winner?.lastName || user?.lastName,
                                email: prize?.winner?.email || user?.email},
                            id});
                    }
                }}
                    cursor={isEditable ? 'pointer': 'unset'}
                    _hover={isEditable ?{ textDecoration: 'underline' }: {}}>
                  <p>
                    Name: {hideString(`${prize?.winner?.firstName || user?.firstName} ${prize?.winner?.lastName || user?.lastName}`, !isHidden)}
                  </p>
                    <Text fontSize="md" letterSpacing="wide" color='white'>{`Phone: ${hideString(user?.phone, !isHidden, 3, true)}`}  </Text>
                  <p>Email: {hideString(user?.email, !isHidden)}</p>
                    <p>Generated at: {parseDateTime(createdAt)}</p>
                    <p>Package: {packageNames?.[0]}</p>

                </Td>
                  <Td>
                      <Button
                          onClick={() => {
                              goTo(place - 1);

                          }}
                          variant='ghost'>
                          Reveal winner
                      </Button>
                  </Td>
                <Td>
                  <Button isDisabled={giveaway?.status ==='finished' || !isEditable}
                          onClick={() => {
                              setDeleteWinnerId(id);
                              onOpen();
                         }}
                          variant='ghost'>
                      <DeleteIcon
                          color='#9FABCB'
                          boxSize={5}
                      />
                  </Button>
                </Td>
              </Tr>
            ))}
          <Tr></Tr>
        </Tbody>
      </Table>
        <Attention
            variant="remove"
            handle={async () => {
                await handleDeleteWinner(deleteWinnerId);
                queryClient.invalidateQueries(['giveawayWinners']);
                onClose();
                setDeleteWinnerId(null);
            }}
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={() => {
                onClose();
                setDeleteWinnerId(null);
            }}
        />
        <WinnerEditModal id={selectedWinner?.id} isOpen={selectedWinner} onClose={()=>setSelectedWinner(null)}  initialValues={selectedWinner?.user} />
    </Card>
  );
}
